export default "__VITE_ASSET__DfQYOcVC__"